import apiClient from '../apiClient';

const API_URL = '/art/etiquetas';

export const getEtiquetasActivas = async () => {
    const response = await apiClient.get(`${API_URL}/activas`);
    return response.data;
};

export const buscarEtiquetas = async (termino) => {
    const response = await apiClient.get(`${API_URL}/buscar`, {
        params: { termino }
    });
    return response.data;
};

export const getEtiquetaPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

export const crearOActualizarEtiqueta = async (etiqueta) => {
    const response = await apiClient.post(API_URL, etiqueta);
    return response.data;
};

export const desactivarEtiqueta = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

